import { render, staticRenderFns } from "./PrimaryColorPicker.vue?vue&type=template&id=27952250&scoped=true&"
import script from "./PrimaryColorPicker.vue?vue&type=script&lang=js&"
export * from "./PrimaryColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27952250",
  null
  
)

export default component.exports